<template>
  <v-btn :type="type" :disabled="disabled" class="btn-add" @click="evOnClick">
    <i class="fas fa-plus mr-2 text-twenty"></i>
    {{ loading ? "CARREGANDO" : text }}
  </v-btn>
</template>

<script>
export default {
  name: "VBtnAdd",

  props: {
    text: { type: String, default: "ADICIONAR" },
    type: { type: String, default: "button" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  methods: {
    async evOnClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style>
</style>